import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationError } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '@app/lib/components/dialog/dialog.component';
import { DialogDataIconEnum, DialogDataModel } from '@app/lib/models/dialog-data.model';
import { DialogService } from './lib/services/dialog.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router, private dialog: MatDialog,private dialogService: DialogService) { }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        const errorMsg = event.error?.toString() || '';
        if (errorMsg.includes('NG04002') || errorMsg.includes('Cannot match any routes')) {
          this.dialogService.openDialog1({
              data: {
                title: "Coming Soon / Not Found",
                message: "The requested module or page is not available yet.",
                icon: "info",
              },
              disableClose: true,
              hasBackdrop: true,
              backdropClass: "dialog-backdrop",
            });
        }
      }
    });
  }
}
